<template>
  <v-menu>
    <template v-slot:activator="{ props }">
      <v-btn icon v-bind="props">
        <v-icon class="primary-color" icon="fa-bars" size="20"/>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, index) in menuItems"
        :key="index"
        :to="item.route"
        :prepend-icon="item.icon"
      >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const menuItems = ref([
  { title: 'Home', route: { name: 'home' }, icon: 'fa-home' },
  { title: 'Appointments', route: { name: 'appointments' }, icon: 'fa-calendar' },
  { title: 'Shop', route: { name: 'shop' }, icon: 'fa-shopping-bag' },
  { title: 'Orders', route: { name: 'orders' }, icon: 'fa-shopping-cart' },
  { title: 'Documents', route: { name: 'document-documents' }, icon: 'fa-file' },
  { title: 'Forms', route: { name: 'document-forms' }, icon: 'fa-list-alt' },
  { title: 'Health Suite', route: { name: 'health-suite' }, icon: 'fa-heart' },
  { title: 'My Profile', route: { name: 'client' }, icon: 'fa-user' },
]);
</script>

<style scoped>
.v-list {
  min-width: 200px;
}
</style> 